export const url =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
export const urlPath = /^[a-z0-9-]*$/;
export const twoDecimalDigits = /^\d\d*[.]?\d{0,2}$/;
export const noSpecialCharacters = /^[a-zA-Z0-9 ]*$/;

// minimum 8 characters, upper and lower case letter, a number and a special character with dot accepted
export const safePassword =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-\\.]).{8,}$/;

export const hideEmail = /(\w{3})[\w.-]+@([\w.]+\w)/;

export const metadataNameCharacters = /[^a-zA-Z0-9 /,-_]/g;

export const alphanumeric = /^[a-zA-Z0-9\s]+$/;
export const alphanumericAndSlash = /^[a-zA-Z0-9\s/]+$/;

export const urlSchema = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/;

export const removeNonASCII = /[^\x00-\x7F]/g;
